import  { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import  Header  from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function Contact() {
      const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

    return (
        <>
            <div className="antialiased light-vz circle-v ">
                <Header events={events} />
                <br></br>
                  <h1 className='spacer-section'></h1>
                {/* Contact Section */}
                <section className="general-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="sec-title white-heading-text">
                                    <span className="icon-inner wow flipInY" data-wow-duration="300ms">
                                        <span className="fa-stack">
                                            <i className="fa rhex fa-stack-2x"></i>
                                            <i className="fa fa-envelope fa-stack-1x"></i>
                                        </span>
                                    </span>
                                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Contact Us</h3>
                                </div> {/* <!--sec-title end--> */}
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="contact-info">
                                    <h4>For General Queries</h4>
                                    <p>
                                        <i className="fa fa-envelope"></i>
                                        info@bsidesbangalore.in
                                    </p>
                                </div>
                            </div>
                            
                            <div className="col-lg-4">
                                <div className="contact-info">
                                    <h4>For Sponsorship</h4>
                                    <p>
                                        <i className="fa fa-envelope"></i>
                                        sponsor@bsidesbangalore.in
                                    </p>
                                </div>
                            </div>
                            
                            <div className="col-lg-4">
                                <div className="contact-info">
                                    <h4>For CFP Queries</h4>
                                    <p>
                                        <i className="fa fa-envelope"></i>
                                        cfp@bsidesbangalore.in
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> 
                <MainWebFooter  />
                <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
            </div>
        </>
    );
}

export default Contact;